export default __webpack_public_path__ + "icon_sunshine.038a896f1308a16ba212f294b9c4b222.svg";